import { Input } from "antd";
import styled from "styled-components";

import { COLOR_GREEN } from "@static/COLORS";

export const StyledInput = styled(Input)`
  &.ant-input-affix-wrapper:focus,
  &.ant-input-affix-wrapper-focused,
  &.ant-input-affix-wrapper:hover {
    border-color: ${COLOR_GREEN} !important;
    box-shadow: 0 0 0 2px rgba(72, 191, 145, 0.2) !important;
  }

  &:focus,
  &:active,
  &:hover {
    border-color: ${COLOR_GREEN} !important;
    box-shadow: 0 0 0 2px rgba(72, 191, 145, 0.2) !important;
  }
`;
